import { IMG } from "../data/site";
import { FadeUp, SectionHead } from "./Motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Heritage on a Tawa",
    body: "Recipes carried from the kitchens of Tamil Nadu, Karnataka and Andhra — batter fermented overnight, chutneys ground each morning, sambhar simmered slow.",
  },
  {
    n: "02",
    title: "Fresh, Without Compromise",
    body: "Premium ingredients, no shortcuts. Every dosa is spread to order on a roaring-hot tawa and arrives at your table crackling.",
  },
  {
    n: "03",
    title: "Hospitality First",
    body: "Sri Dosa Express is known for exceptional, family-friendly hospitality. Every dish is prepared with care to deliver a memorable dining experience.",
  },
];

const About = () => (
  <section id="about" data-testid="about-section" className="relative mx-auto max-w-7xl px-5 py-32 md:px-10 md:py-40">
    <SectionHead
      index="01"
      kicker="Our Story"
      title={<>Crafted with care, <em className="italic text-gold">served with pride</em></>}
    />

    <div className="grid grid-cols-1 gap-14 md:grid-cols-12 md:gap-8">
      <FadeUp className="md:col-span-5">
        <div className="overflow-hidden rounded-t-[10rem] border border-white/10">
          <img
            src={IMG.aboutChef}
            alt="Chef plating a dish under warm light"
            loading="lazy"
            className="h-[420px] w-full object-cover transition-transform duration-700 hover:scale-105 md:h-[540px]"
          />
        </div>
        <p className="mt-4 text-[11px] uppercase tracking-[0.3em] text-white/40">The tawa never rests</p>
      </FadeUp>

      <div className="flex flex-col justify-between gap-12 md:col-span-6 md:col-start-7">
        {CHAPTERS.map((c, i) => (
          <FadeUp key={c.n} delay={i * 0.12}>
            <div className="group flex gap-6 border-b border-white/10 pb-10" data-testid={`about-chapter-${c.n}`}>
              <span className="font-serif text-4xl text-gold/40 transition-colors duration-500 group-hover:text-gold md:text-5xl">{c.n}</span>
              <div>
                <h3 className="font-serif text-2xl text-white md:text-3xl">{c.title}</h3>
                <p className="mt-3 max-w-md leading-relaxed text-mist">{c.body}</p>
              </div>
            </div>
          </FadeUp>
        ))}
        <FadeUp delay={0.3}>
          <div className="overflow-hidden rounded-2xl border border-white/10">
            <img
              src={IMG.aboutSpread}
              alt="South Indian breakfast spread on banana leaves"
              loading="lazy"
              className="h-52 w-full object-cover transition-transform duration-700 hover:scale-105"
            />
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);

export default About;
